export const GET_NOTIFICATION_OVERVIEW_REQUEST =
  'GET_NOTIFICATION_OVERVIEW_REQUEST';
export const GET_NOTIFICATION_OVERVIEW_SUCCESS =
  'GET_NOTIFICATION_OVERVIEW_SUCCESS';
export const GET_NOTIFICATION_OVERVIEW_FAIL = 'GET_NOTIFICATION_OVERVIEW_FAIL';
